import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import ActivityCard from '../ActivityCard'
import moment from 'moment-timezone'

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05
    }
  }
}

export default function Activities ({ activities, day }) {


  const dayActivities = activities.filter(it => moment(it.StartsAt).isSame(day, 'day'))

  return (
   <Container key={day} variants={containerVariants} initial="hidden" animate="visible">
     {dayActivities.map(activity => (
       <ActivityCard
         name={activity.Name}
         description={activity.Description}
         location={activity.Location}
         speakers={activity.Included?.Speakers}
         startsAt={activity.StartsAt}
         endsAt={activity.EndsAt}
       />
     ))}
   </Container>
  )
}

const Container = styled(motion.div)`
  min-height: 60rem;
`